<template>
    <div>
        <div class="row form-group">
            <label class="col-sm-2">Name</label>
            <div class="col-sm-6">
                <el-input v-model="formData.name"></el-input>
            </div>
        </div>

        <div class="row form-group" style="align-items: flex-start">
            <label class="col-sm-2">Logo</label>
            <div class="col-sm-6">
                <el-upload
                    class="dispatcher-logo-uploader"
                    :action="url(`admin/settings/dispatchers/logo`)"
                    :show-file-list="false"
                    :on-success="handleLogoSuccess"
                    :before-upload="beforeLogoUpload"
                >
                        <img v-if="formData.logo_url" :src="formData.logo_url" class="logo">
                    <i v-else class="el-icon-plus dispatcher-logo-uploader-icon"></i>
                </el-upload>
                
                <el-button 
                    v-if="formData.id && formData.logo_id"
                    size="small"
                    @click="deleteLogo()"
                >
                    Delete logo
                </el-button>
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-2">Phone</label>
            <div class="col-sm-6">
                <el-input v-model="formData.phone"></el-input>
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-2">Email</label>
            <div class="col-sm-6">
                <el-input v-model="formData.email"></el-input>
                <p style="font-size:0.8em;padding-top:5px">comma separated list</p>
            </div>
        </div>

        <div class="row form-group" style="margin-top: 30px">
            <label class="col-sm-2">Short Info</label>
            <div class="col-sm-9">
                <div v-for="(info, index) in formData.info_short" style="display: flex; align-items: baseline; margin-bottom: 5px">
                    <el-input 
                        v-model="info.text"
                        size="small" 
                    ></el-input>

                    <a href="#" @click.prevent="removeInfoShortRow(index)" style="margin-left: 15px; margin-right: 10px; color: red">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                </div>

                <el-button size="small" @click="addInfoShortRow()" style="floar: right">Add row</el-button>
            </div>
        </div>

        <div class="row form-group" style="margin-top: 30px">
            <label class="col-sm-2">Long Info</label>
            <div class="col-sm-9">
                <div v-for="(info, index) in formData.info_long" style="display: flex; align-items: baseline; margin-bottom: 5px">
                    <el-input 
                        v-model="info.text"
                        size="small" 
                    ></el-input>

                    <a href="#" @click.prevent="removeInfoLongRow(index)" style="margin-left: 15px; margin-right: 10px; color: red">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                </div>

                <el-button size="small" @click="addInfoLongRow()" style="floar: right">Add row</el-button>
            </div>
        </div>

        <div class="row form-group" style="margin-top: 30px">
            <label class="col-sm-2"></label>
            <div class="col-sm-9">
                <el-checkbox v-model="formData.is_primary">Highlight border</el-checkbox>
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-2"></label>
            <div class="col-sm-9">
                <el-checkbox v-model="formData.is_click_to_call">Click-to-call</el-checkbox>
            </div>
        </div>

        <div class="row form-group">
            <label class="col-sm-2"></label>
            <div class="col-sm-9">
                <el-checkbox v-model="formData.is_inactive">Inactive</el-checkbox>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: [
            'formData',
        ],
        data() {
            return {};
        },
        methods: {
            addInfoShortRow: function () {
                this.formData.info_short.push({ text: '' });
            },
            removeInfoShortRow: function (index) {
                this.formData.info_short.splice(index, 1);
            },
            addInfoLongRow: function () {
                this.formData.info_long.push({ text: '' });
            },
            removeInfoLongRow: function (index) {
                this.formData.info_long.splice(index, 1);
            },

            // Logo
            handleLogoSuccess(response, file) {
                this.$message({
                    message: `Logo has been upload`,
                    type: 'success'
                });

                this.formData.logo_id = response.logo_id;
                this.formData.logo_url = response.logo_url;
            },
            beforeLogoUpload(file) {
                const isOverLimit = file.size / 1024 / 1024 < 1;

                if (!isOverLimit) {
                    this.$message.error('Logo size can not exceed 1MB!');
                }
                return isOverLimit;
            },
            deleteLogo() {
                return axios.delete(url(`admin/settings/dispatchers/logo/${this.formData.id}`))
                .then((response) => {                    
                    this.$message({
                        message: `Logo has been deleted`,
                        type: 'success'
                    });

                    this.formData.logo_id = "";
                    this.formData.logo_url = "";
                });
            },
        }
    }
</script>

<style scoped>
    div.row {
        display: flex; align-items: baseline
    }
    label {
        font-weight: normal
    }
    .logo {
        display: block;
    }
    
</style>

<style>
    .dispatcher-logo-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 5px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .dispatcher-logo-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .dispatcher-logo-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .dispatcher-logo-uploader input[type="file"] {
        display: none;
    }
</style>